// Hides the trending/popular block once the user starts typing, so it doesn't overlap
// Shopify's native predictive search results.
(function () {
  function wireUp(input) {
    var form = input.closest('form');
    if (!form) return;
    var block = form.querySelector('[data-search-trending-popular]');
    if (!block) return;
    function update() {
      block.style.display = input.value.trim().length > 0 ? 'none' : '';
    }
    input.addEventListener('input', update);
    update();
  }
  function init() {
    document.querySelectorAll('.search__input').forEach(wireUp);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
